"use strict";

const Region = require('./Region');
const Province = require('./Province');
const District = require('./District');

/**
 * Obtener el nombre del departamenteo, provincia y distrito
 * @param {String} codUbigeo código de ubigeo
 * @return {Object}
 */
function _getUbigeo(codUbigeo) {
  const district = new District(codUbigeo);

  const province = district.getProvince();

  const region = province.getRegion();

  return {
    region: region.getName(),
    province: province.getName(),
    district: district.getName(),
  };
}

exports = module.exports = _getUbigeo;

exports.Region = Region;
exports.Province = Province;
exports.District = District;
